import React from 'react';
import './skills.css';
import react from '../assets/react.png'
import c from '../assets/c++.png'
import node from '../assets/node.png'
import firebase from '../assets/firebase.png'
import html from '../assets/html.png'
import css from '../assets/css.png'
import git from '../assets/git.png'
import mongo from '../assets/mongo.png'
import js from '../assets/js.png'
import python from '../assets/python.png'
import sql from '../assets/sql.png'
import langchain from '../assets/langchain.png'
import tensorflow from '../assets/Tensorflow.png'

const Skills = () => {
  const skillsData = [
    { icon: js, name: 'Javascript' },
    { icon: python, name: 'Python' },
    { icon: c, name: 'C++' },
    { icon: react, name: 'React.js' },
    { icon: node, name: 'Node.js' },
    { icon: html, name: 'HTML' },
    { icon: css, name: 'CSS3' },
    { icon: langchain, name: 'langchain' },
    { icon: mongo, name: 'Mongo DB' },
    { icon: git, name: 'Git/ GitHub' },
    { icon: firebase, name: 'Firebase' },
    { icon: sql, name: 'MySQL' },
    { icon: tensorflow, name: 'TensorFlow' },
    // Add more skills as needed
  ];

  return (
    <div className="skills-content">
      <h2 className="section-title">My Skills</h2>
      <div className="skills-list">
        {skillsData.map((skill, index) => (
          <div className="skill" key={index}>
            <img src={skill.icon} alt={skill.name} className='skill-icon'/>
            <p className='skill-name'>{skill.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
